import { XepptClient } from '@xeppt/xeppt-sdk';

const BASE = '/admin/eps/settings';

export type TEpsSettingsSource = 'db' | 'env';

export type TEpsSettings = {
    endpoint: string;
    merchant_id: string;
    access_key: string;
    timeout_seconds: number;
    enabled: boolean;
    api_secret_set: boolean;
    api_secret_last4: string;
    api_secret_rotated_at: string | null;
    api_secret_prev_set: boolean;
    webhook_secret_set: boolean;
    webhook_secret_last4: string;
    webhook_secret_rotated_at: string | null;
    webhook_secret_prev_set: boolean;
    source: {
        endpoint: TEpsSettingsSource;
        merchant_id: TEpsSettingsSource;
        access_key: TEpsSettingsSource;
        timeout_seconds: TEpsSettingsSource;
        enabled: TEpsSettingsSource;
        api_secret: TEpsSettingsSource;
        webhook_secret: TEpsSettingsSource;
    };
    updated_at: string | null;
    updated_by: string | null;
};

export type TEpsConnectionTestResult = {
    ok: boolean;
    detail: string;
};

export type TEpsSettingsAuditItem = {
    action: string;
    field: string;
    actor: string;
    at: string;
};

export type TEpsSettingsAudit = {
    items: TEpsSettingsAuditItem[];
    total: number;
};

export class EpsSettingsService {
    constructor(private readonly client: XepptClient) {}

    getSettings(): Promise<TEpsSettings> {
        return this.client.request({ method: 'GET', url: BASE });
    }

    updateSettings(payload: {
        endpoint: string;
        merchant_id: string;
        access_key: string;
        timeout_seconds: number;
        enabled: boolean;
    }): Promise<void> {
        return this.client.request({ method: 'PUT', url: BASE, body: payload });
    }

    rotateApiSecret(api_secret: string): Promise<void> {
        return this.client.request({
            method: 'POST',
            url: `${BASE}/api-secret/rotate`,
            body: { api_secret }
        });
    }

    rotateWebhookSecret(webhook_secret: string): Promise<void> {
        return this.client.request({
            method: 'POST',
            url: `${BASE}/webhook-secret/rotate`,
            body: { webhook_secret }
        });
    }

    testConnection(): Promise<TEpsConnectionTestResult> {
        return this.client.request({ method: 'POST', url: `${BASE}/test-connection` });
    }

    getAudit(limit: number, offset: number): Promise<TEpsSettingsAudit> {
        return this.client.request({
            method: 'GET',
            url: `${BASE}/audit`,
            query: { limit, offset }
        });
    }
}
